"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Contract = __importStar(require("@tableau/api-external-contract-js"));
const api_shared_js_1 = require("@tableau/api-shared-js");
const AuthoringWorksheetImpl_1 = require("../Impl/AuthoringWorksheetImpl");
const AuthoringWorksheet_1 = require("./AuthoringWorksheet");
class AuthoringWorkbook {
    constructor(_workbookImpl, _registryId) {
        this._workbookImpl = _workbookImpl;
        this._registryId = _registryId;
    }
    get activeSheet() {
        if (this._workbookImpl.activeSheet.sheetType === Contract.SheetType.Worksheet) {
            const authoringWorksheetImpl = new AuthoringWorksheetImpl_1.AuthoringWorksheetImpl(this._registryId);
            return new AuthoringWorksheet_1.AuthoringWorksheet(authoringWorksheetImpl);
        }
        throw new api_shared_js_1.TableauError(Contract.EmbeddingErrorCodes.InvalidSheetType, 'Worksheet type not yet supported in Authoring');
    }
}
exports.AuthoringWorkbook = AuthoringWorkbook;
//# sourceMappingURL=AuthoringWorkbook.js.map